import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauAnnulerAction from '../actions/BordereauAnnulerAction';
import BordereauDenumeroterAction from '../actions/BordereauDenumeroterAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauEmettreLeFlux360Action from '../actions/BordereauEmettreLeFlux360Action';
import BordereauEmettreLeFluxAction from '../actions/BordereauEmettreLeFluxAction';
import BordereauRejeterCollectiviteAction from '../actions/BordereauRejeterCollectiviteAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauNumeroteState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.NUMEROTE;
		this.state = BordereauStateType.NUMEROTE;
		this.color = '#006666';
		this.libelle = 'Numéroté';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauEmettreLeFluxAction({ isActionPrincipale: true }),
			new BordereauEmettreLeFlux360Action(),
			new BordereauDupliquerAction(),
			...(userRole === UserRole.ADMIN
				? [
						new BordereauDenumeroterAction({ isSuperUser: true }),
						new BordereauRejeterCollectiviteAction({ isSuperUser: true }),
						new BordereauAnnulerAction({ isSuperUser: true }),
					]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			new MouvementDupliquerAction(),
			...this.getActionsAnnulationRejet(),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauNumeroteState;
